// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// import axiosInstance from "../../../axiosinterceptor";
// import pako from "pako";
// import { saveCodebookToIndexedDB,getCodebookFromIndexedDB} from "../../../utils/indexedDB";


// const decompressData = (data) => {
//   if (data?.body) {
//     try {
//       const decompressedBody = pako.ungzip(
//         Uint8Array.from(atob(data.body), (c) => c.charCodeAt(0)),
//         { to: "string" }
//       );
//       return JSON.parse(decompressedBody);
//     } catch (error) {
//       console.error("Error decompressing data:", error);
//       return null;
//     }
//   }
//   return null;
// };

// const initialState = {
//   // 12th Edition
//   icd10amTabularData: [],
//   icd10amIndexData: [],
//   achiIndexData: [],
//   achiTabularData: [],
//   pcsIndexData: [],
//   pcsTabularData: [],

//   // 13th Edition
//   icd10amTabularData13: [],
//   icd10amIndexData13: [],
//   achiIndexData13: [],
//   achiTabularData13: [],

//   codeBookLoading: false,
//   codeBookError: {},
//   acsCode: "",
//   isFetched12: false,
//   isFetched13: false,
// };

// export const fetchCodebookData = createAsyncThunk(
//   "codebook/fetchData12",
//   async (_, { dispatch }) => {
//     dispatch(fetchCodebookDataPending());

//     // Try from cache
//     const cachedData = await getCodebookFromIndexedDB("codebookData12");
//         console.log("[IndexedDB] Checking cache for 'codebookData12'...");

//     if (cachedData) {
//       console.log("[IndexedDB] Cache hit for 'codebookData12'. Using cached data.");

//       dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData", data: cachedData.icd10amTabularData }));
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData", data: cachedData.icd10amIndexData }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData", data: cachedData.achiIndexData }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData", data: cachedData.achiTabularData }));
//       dispatch(fetchCodebookDataUpdate({ type: "pcsIndexData", data: cachedData.pcsIndexData }));
//       dispatch(fetchCodebookDataUpdate({ type: "pcsTabularData", data: cachedData.pcsTabularData }));

//       // Set flag in sessionStorage
//       sessionStorage.setItem("isFetched12", "true");
//       return;
//     }
//         console.log("[IndexedDB] No cache found. Fetching data from API...");

//     let icd10amTabularRes, icd10amIndexRes, achiIndexRes, achiTabularRes, pcsIndexRes, pcsTabularRes;

//     try {
//       icd10amTabularRes = await axiosInstance.get("/codebook_acs");
//       dispatch(fetchCodebookDataUpdate({ type: 'icd10amTabularData', data: decompressData(icd10amTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: 'icd10amTabularData', error: err.message || "Failed to fetch ICD10AM Tabular" }));
//     }

//     try {
//       icd10amIndexRes = await axiosInstance.get("/index_codebook_acs");
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData", data: decompressData(icd10amIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "icd10amIndexData", error: err.message }));
//     }

//     try {
//       achiIndexRes = await axiosInstance.get("/AchiCodebookIndex");
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData", data: decompressData(achiIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiIndexData", error: err.message }));
//     }

//     try {
//       achiTabularRes = await axiosInstance.get("/achi_codebook_tabular");
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData", data: decompressData(achiTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiTabularData", error: err.message }));
//     }
//     try {
//       pcsIndexRes = await axiosInstance.get("/codebookIndex6");
//       dispatch(fetchCodebookDataUpdate({ type: "pcsIndexData", data: decompressData(pcsIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "pcsIndexData", error: err.message || "Failed to fetch PCS Index" }));
//     }

//     try {
//       pcsTabularRes = await axiosInstance.get("/codebookIndex5");
//       dispatch(fetchCodebookDataUpdate({ type: "pcsTabularData", data: decompressData(pcsTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "pcsTabularData", error: err.message || "Failed to fetch PCS Tabular" }));
//     }
//     const codebookData12 = {
//       icd10amTabularData: decompressData(icd10amTabularRes?.data),
//       icd10amIndexData: decompressData(icd10amIndexRes?.data),
//       achiIndexData: decompressData(achiIndexRes?.data),
//       achiTabularData: decompressData(achiTabularRes?.data),
//       pcsIndexData: decompressData(pcsIndexRes?.data),
//       pcsTabularData: decompressData(pcsTabularRes?.data),
//     };

//     await saveCodebookToIndexedDB("codebookData12", codebookData12);
//      sessionStorage.setItem("isFetched12", "true");
//     console.log("[IndexedDB] Saved 'codebookData12' to IndexedDB ✅");

//   }

// );

// export const fetchCodebookData13 = createAsyncThunk(
//   "codebook/fetchData13",
//   async (_, { dispatch }) => {
//     dispatch(fetchCodebookDataPending());

//     // Try to load from IndexedDB
//     const cachedData = await getCodebookFromIndexedDB("codebookData13");
//     if (cachedData) {
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData13", data: cachedData.icd10amTabularData13 }));
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData13", data: cachedData.icd10amIndexData13 }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData13", data: cachedData.achiIndexData13 }));
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData13", data: cachedData.achiTabularData13 }));

//       //  Set sessionStorage flag
//       sessionStorage.setItem("isFetched13", "true");
//       return;
//     }
//     let icd10amTabularRes, icd10amIndexRes, achiIndexRes, achiTabularRes;

//     try {
//       icd10amTabularRes = await axiosInstance.get("/codebook_acs_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData13", data: decompressData(icd10amTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "icd10amTabularData13", error: err.message }));
//     }

//     try {
//       icd10amIndexRes = await axiosInstance.get("/index_codebook_acs_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData13", data: decompressData(icd10amIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "icd10amIndexData13", error: err.message }));
//     }

//     try {
//       achiIndexRes = await axiosInstance.get("/AchiCodebookIndex_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "achiIndexData13", data: decompressData(achiIndexRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiIndexData13", error: err.message }));
//     }

//     try {
//       achiTabularRes = await axiosInstance.get("/achi_codebook_tabular_v13");
//       dispatch(fetchCodebookDataUpdate({ type: "achiTabularData13", data: decompressData(achiTabularRes.data) }));
//     } catch (err) {
//       dispatch(fetchCodebookDataError({ type: "achiTabularData13", error: err.message }));
//     }
//     const codebookData13 = {
//       icd10amTabularData13: decompressData(icd10amTabularRes?.data),
//       icd10amIndexData13: decompressData(icd10amIndexRes?.data),
//       achiIndexData13: decompressData(achiIndexRes?.data),
//       achiTabularData13: decompressData(achiTabularRes?.data),
//     };

//     await saveCodebookToIndexedDB("codebookData13", codebookData13);
//       sessionStorage.setItem("isFetched13", "true");
//   }
// );

// const codebookSlice = createSlice({
//   name: "codebook",
//   initialState,
//   reducers: {
//     fetchCodebookDataPending: (state) => {
//       state.codeBookLoading = true;
//       state.codeBookError = {};
//       state.completedCalls = 0;
//       //     if (!state.isFetched12 && !state.isFetched13) {
//       //   state.codeBookLoading = true;
//       // }
//     },
//     fetchCodebookDataUpdate: (state, action) => {
//       state[action.payload.type] = action.payload.data;
//       state.completedCalls = (state.completedCalls || 0) + 1;

//       // Mark 12th fetched
//       if (["icd10amTabularData", "icd10amIndexData", "achiIndexData", "achiTabularData", "pcsIndexData", "pcsTabularData"].includes(action.payload.type)) {
//         if (
//           state.icd10amTabularData &&
//           state.icd10amIndexData &&
//           state.achiIndexData &&
//           state.achiTabularData &&
//           state.pcsIndexData &&
//           state.pcsTabularData
//         ) {
//           state.isFetched12 = true;
//         }
//       }
//       // Mark 13th fetched
//       if (["icd10amTabularData13", "icd10amIndexData13", "achiIndexData13", "achiTabularData13"].includes(action.payload.type)) {
//         if (
//           state.icd10amTabularData13 &&
//           state.icd10amIndexData13 &&
//           state.achiIndexData13 &&
//           state.achiTabularData13
//         ) {
//           state.isFetched13 = true;
//         }
//       }

//       if (state.completedCalls >= 4 && state.completedCalls % 4 === 0) {
//         state.codeBookLoading = false;
//       }
//     },
//     fetchCodebookDataError: (state, action) => {
//       state.codeBookError[action.payload.type] = action.payload.error;
//       state.codeBookLoading = false;
//     },
//     updateAcsCode: (state, action) => {
//       state.acsCode = action.payload;
//     },
//     clearAcsCode: (state) => {
//       state.acsCode = "";
//     },
//   },
// });

// export const {
//   fetchCodebookDataPending,
//   fetchCodebookDataUpdate,
//   fetchCodebookDataError,
//   updateAcsCode,
//   clearAcsCode,
// } = codebookSlice.actions;

// export default codebookSlice.reducer;

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";
import pako from "pako";
import { saveCodebookToIndexedDB, getCodebookFromIndexedDB } from "../../../utils/indexedDB";
import { logMemory, logDataSize, logFetchCall } from "./MemoryDebug";

const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;

// --- Helper to decompress ---
const decompressData = (data) => {
  try {
    if (!data) return null;
    const compressedBody = typeof data === "string" ? data : data?.body;
    if (!compressedBody) {
      console.warn("No compressed body found:", data);
      return null;
    }

    const binaryString = atob(compressedBody);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i); // direct indexed write, no callback per byte
    }

    const decompressedBody = pako.ungzip(bytes, { to: "string" });
    return JSON.parse(decompressedBody);
  } catch (error) {
    console.error("Error decompressing data:", error);
    return null;
  }
};

const getCompressedCodebookData = async (endPoint, viaBucket = false) => {
  try {
    const isUSA = process.env.REACT_APP_FLAG_USA;

    if (viaBucket && !isUSA) {

      const response = await axiosInstance.get(endPoint);
      const bucketURL = response?.data?.download_url;
      const bucketResponse = await fetch(bucketURL);
      if (!bucketResponse.ok) {
        throw new Error(`S3 fetch failed: ${bucketResponse.status}`);
      }
      return await bucketResponse.text();
    } else {
      const response = await axiosInstance.get(endPoint);
      return response?.data;
    }
  } catch (error) {
    console.error("Codebook fetch error:", error);
    throw error;
  }
};

// Guards — reset ONLY in `finally`, after the whole batch chain settles.
// Resetting mid-flight let duplicate fetches stack on top of each other
// and was the main driver of the earlier OOM.
const codebookFetchStarted = {
  "12th": false,
  "13th": false,
};

const initialState = {
  icd10amTabularData: [],
  icd10amIndexData: [],
  achiIndexData: [],
  achiTabularData: [],
  pcsIndexData: [],
  pcsTabularData: [],
  icd10amTabularData13: [],
  icd10amIndexData13: [],
  achiIndexData13: [],
  achiTabularData13: [],

  isFetched12: false,
  isFetched13: false,
  codeBookLoading: false,

  codeBookError: {},
  acsCode: "",
  ncaCode: "",
  activeTab: codebookdevEnv ? "ICD 10 AM Index" : "ICD 10 CM Index",
  activeIcon: "ICD",
  rawSearchQuery: "",
  searchQuery: "",
  searchByCodeId: null,
  onChangeCodeBook: false,
  nondraggablecode: false,
  selectedCodebookVersion: "13th",
  documentSearchQuery: "",
};


const loadStep = async ({ dispatch, type, endpoint, viaBucket, idbKey, group }) => {
  const data = decompressData(await getCompressedCodebookData(endpoint, viaBucket));
  dispatch(fetchCodebookDataUpdate({ type, data, group }));

  // Fire-and-forget — Redux already has the data dispatched; the write
  // is only for warm-cache-on-refresh and shouldn't gate the next batch.
  saveCodebookToIndexedDB(idbKey, data).catch((err) =>
    console.error(`IndexedDB save failed for ${idbKey}:`, err)
  );

  return data;
};

export const fetchCodebookData13 = createAsyncThunk(
  "codebook/fetchData13",
  async (_, { dispatch, getState }) => {
    // logFetchCall("fetchCodebookData13");

    if (codebookFetchStarted["13th"]) {
      console.log("[GUARD] 13th fetch blocked — already in flight");
      return;
    }
    if (getState().codeBook.isFetched13) return; // already loaded, skip

    codebookFetchStarted["13th"] = true;
    dispatch(fetchCodebookDataPending());
    // logMemory("before 13th fetch");
    

    try {
      // Cache check — read each key individually.
      const cachedIcdIndex = await getCodebookFromIndexedDB("codebookData13:icd10amIndexData13");
      const cachedAchiIndex = await getCodebookFromIndexedDB("codebookData13:achiIndexData13");
      const cachedIcdTabular = await getCodebookFromIndexedDB("codebookData13:icd10amTabularData13");
      const cachedAchiTabular = await getCodebookFromIndexedDB("codebookData13:achiTabularData13");

      if (cachedIcdIndex && cachedAchiIndex && cachedIcdTabular && cachedAchiTabular) {
        dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData13", data: cachedIcdIndex, group: "13th" }));
        dispatch(fetchCodebookDataUpdate({ type: "achiIndexData13", data: cachedAchiIndex, group: "13th" }));
        dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData13", data: cachedIcdTabular, group: "13th" }));
        dispatch(fetchCodebookDataUpdate({ type: "achiTabularData13", data: cachedAchiTabular, group: "13th" }));
        // logMemory("after 13th fetch (from cache)");
        return;
      }

      // BATCH 1 — Index pair, fetched in parallel. Network I/O overlaps;
      // each dispatches the moment its own response is ready.
      await Promise.all([
        loadStep({
          dispatch, type: "icd10amIndexData13",
          endpoint: "/index_codebook_acs_v13_v2", viaBucket: true,
          idbKey: "codebookData13:icd10amIndexData13", group: "13th",
        }),
        loadStep({
          dispatch, type: "achiIndexData13",
          endpoint: "/AchiCodebookIndex_v13_v2", viaBucket: true,
          idbKey: "codebookData13:achiIndexData13", group: "13th",
        }),
      ]);
      // logMemory("after 13th index batch (parallel)");

      // BATCH 2 — Tabular pair, starts only after Index batch's buffers
      // have gone out of scope. Also fetched in parallel with each other.
      await Promise.all([
        loadStep({
          dispatch, type: "icd10amTabularData13",
          endpoint: "/codebook_acs_v13_v2", viaBucket: true,
          idbKey: "codebookData13:icd10amTabularData13", group: "13th",
        }),
        loadStep({
          dispatch, type: "achiTabularData13",
          endpoint: "/achi_codebook_tabular_v13_v2", viaBucket: true,
          idbKey: "codebookData13:achiTabularData13", group: "13th",
        }),
      ]);
      // logMemory("after 13th tabular batch (parallel, fetch complete)");
    } catch (err) {
      console.error("API fetch error (13th):", err);
      dispatch(fetchCodebookDataError({ type: "codebook13", error: err.message }));
    } finally {
      codebookFetchStarted["13th"] = false;
    }
  }
);


// 12th EDITION — same batching pattern (+ PCS pair for USA, batch 3)
export const fetchCodebookData = createAsyncThunk(
  "codebook/fetchData12",
  async (_, { dispatch, getState }) => {
    // logFetchCall("fetchCodebookData12");

    if (codebookFetchStarted["12th"]) {
      console.log("[GUARD] 12th fetch blocked — already in flight");
      return;
    }
    if (getState().codeBook.isFetched12) return;

    codebookFetchStarted["12th"] = true;
    dispatch(fetchCodebookDataPending());
    // logMemory("before 12th fetch");

    const isUSA = process.env.REACT_APP_FLAG_USA;

    try {
      const cachedIcdIndex = await getCodebookFromIndexedDB("codebookData12:icd10amIndexData");
      const cachedAchiIndex = await getCodebookFromIndexedDB("codebookData12:achiIndexData");
      const cachedIcdTabular = await getCodebookFromIndexedDB("codebookData12:icd10amTabularData");
      const cachedAchiTabular = await getCodebookFromIndexedDB("codebookData12:achiTabularData");
      const cachedPcsIndex = isUSA ? await getCodebookFromIndexedDB("codebookData12:pcsIndexData") : null;
      const cachedPcsTabular = isUSA ? await getCodebookFromIndexedDB("codebookData12:pcsTabularData") : null;

      const allCached =
        cachedIcdIndex && cachedAchiIndex && cachedIcdTabular && cachedAchiTabular &&
        (!isUSA || (cachedPcsIndex && cachedPcsTabular));

      if (allCached) {
        dispatch(fetchCodebookDataUpdate({ type: "icd10amIndexData", data: cachedIcdIndex, group: "12th" }));
        dispatch(fetchCodebookDataUpdate({ type: "achiIndexData", data: cachedAchiIndex, group: "12th" }));
        dispatch(fetchCodebookDataUpdate({ type: "icd10amTabularData", data: cachedIcdTabular, group: "12th" }));
        dispatch(fetchCodebookDataUpdate({ type: "achiTabularData", data: cachedAchiTabular, group: "12th" }));
        if (isUSA) {
          dispatch(fetchCodebookDataUpdate({ type: "pcsIndexData", data: cachedPcsIndex, group: "12th" }));
          dispatch(fetchCodebookDataUpdate({ type: "pcsTabularData", data: cachedPcsTabular, group: "12th" }));
        }
        // logMemory("after 12th fetch (from cache)");
        return;
      }

      // BATCH 1 — Index pair, parallel.
      await Promise.all([
        loadStep({
          dispatch, type: "icd10amIndexData",
          endpoint: "/index_codebook_acs_v2", viaBucket: true,
          idbKey: "codebookData12:icd10amIndexData", group: "12th",
        }),
        loadStep({
          dispatch, type: "achiIndexData",
          endpoint: "/AchiCodebookIndex_v2", viaBucket: true,
          idbKey: "codebookData12:achiIndexData", group: "12th",
        }),
      ]);
      // logMemory("after 12th index batch (parallel)");

      // BATCH 2 — Tabular pair, parallel.
      await Promise.all([
        loadStep({
          dispatch, type: "icd10amTabularData",
          endpoint: "/codebook_acs_v2", viaBucket: true,
          idbKey: "codebookData12:icd10amTabularData", group: "12th",
        }),
        loadStep({
          dispatch, type: "achiTabularData",
          endpoint: "/achi_codebook_tabular_v2", viaBucket: true,
          idbKey: "codebookData12:achiTabularData", group: "12th",
        }),
      ]);
      // logMemory("after 12th tabular batch (parallel)");

      // BATCH 3 — PCS pair, USA only, parallel.
      if (isUSA) {
        await Promise.all([
          loadStep({
            dispatch, type: "pcsIndexData",
            endpoint: "/codebookIndex6", viaBucket: false,
            idbKey: "codebookData12:pcsIndexData", group: "12th",
          }),
          loadStep({
            dispatch, type: "pcsTabularData",
            endpoint: "/codebookIndex5", viaBucket: false,
            idbKey: "codebookData12:pcsTabularData", group: "12th",
          }),
        ]);
        // logMemory("after 12th pcs batch (parallel, fetch complete)");
      }
    } catch (err) {
      console.error("API fetch error (12th):", err);
      dispatch(fetchCodebookDataError({ type: "codebook12", error: err.message }));
    } finally {
      codebookFetchStarted["12th"] = false;
    }
  }
);

const codebookSlice = createSlice({
  name: "codebook",
  initialState,
  reducers: {
    fetchCodebookDataPending: (state) => {
      state.codeBookLoading = true;
      state.codeBookError = {};
    },

    fetchCodebookDataUpdate: (state, action) => {
      const { type, data, group } = action.payload;
      state[type] = data;

      if (group === "13th") {
        if (
          state.icd10amIndexData13 && state.achiIndexData13 &&
          state.icd10amTabularData13 && state.achiTabularData13
        ) {
          state.isFetched13 = true;
          state.codeBookLoading = false;
        }
      } else if (group === "12th") {
        const isUSA = process.env.REACT_APP_FLAG_USA;
        const ready = isUSA
          ? state.icd10amIndexData && state.achiIndexData &&
            state.icd10amTabularData && state.achiTabularData &&
            state.pcsIndexData && state.pcsTabularData
          : state.icd10amIndexData && state.achiIndexData &&
            state.icd10amTabularData && state.achiTabularData;
        if (ready) {
          state.isFetched12 = true;
          state.codeBookLoading = false;
        }
      }
    },

    fetchCodebookDataError: (state, action) => {
      state.codeBookError[action.payload.type] = action.payload.error;
      state.codeBookLoading = false;
    },

    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setActiveIcon: (state, action) => {
      state.activeIcon = action.payload;
    },
    setRawSearchQuery: (state, action) => {
      state.rawSearchQuery = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSearchByCodeId: (state, action) => {
      state.searchByCodeId = action.payload;
    },
    updateAcsCode: (state, action) => {
      state.acsCode = action.payload;
    },

    // Evict the OTHER edition's data on switch — never hold both
    // editions' full dataset sets in memory at once. Still cached in
    // IndexedDB, so switching back is a fast local read, not a re-fetch.
    setSelectedCodebookVersion: (state, action) => {
      const newVersion = action.payload;
      if (newVersion !== state.selectedCodebookVersion) {
        if (newVersion === "13th") {
          state.icd10amTabularData = [];
          state.icd10amIndexData = [];
          state.achiIndexData = [];
          state.achiTabularData = [];
          state.pcsIndexData = [];
          state.pcsTabularData = [];
          state.isFetched12 = false;
          codebookFetchStarted["12th"] = false;
        } else {
          state.icd10amTabularData13 = [];
          state.icd10amIndexData13 = [];
          state.achiIndexData13 = [];
          state.achiTabularData13 = [];
          state.isFetched13 = false;
          codebookFetchStarted["13th"] = false;
        }
      }
      state.selectedCodebookVersion = newVersion;
    },

    setOnChangeCodeBook: (state, action) => {
      state.onChangeCodeBook = action.payload;
    },
    setNondraggablecode: (state, action) => {
      state.nondraggablecode = action.payload;
    },

    handleResetSearch: (state, action) => {
      const payload = action.payload;
      if (payload?.id) {
        state.searchByCodeId = payload.id;
        state.rawSearchQuery = payload.rawSearchQuery || "";
      } else if (payload?.rawSearchQuery) {
        state.rawSearchQuery = payload.rawSearchQuery;
        state.searchByCodeId = null;
      } else {
        state.searchByCodeId = null;
        state.rawSearchQuery = "";
      }
    },

    clearAcsCode: (state) => {
      state.acsCode = "";
    },
    updateNcaCode: (state, action) => {
      state.ncaCode = action.payload;
    },
    setDocumentSearchQuery: (state, action) => {
    state.documentSearchQuery = action.payload;
  },

  clearDocumentSearchQuery: (state) => {
    state.documentSearchQuery = "";
  },
  },
});

export const {
  fetchCodebookDataPending,
  fetchCodebookDataUpdate,
  fetchCodebookDataError,
  updateAcsCode,
  updateNcaCode,
  setSelectedCodebookVersion,
  clearAcsCode,
  setActiveTab,
  setActiveIcon,
  setRawSearchQuery,
  setSearchQuery,
  setSearchByCodeId,
  handleResetSearch,
  setOnChangeCodeBook,
  setNondraggablecode,
  setDocumentSearchQuery,
  clearDocumentSearchQuery,
} = codebookSlice.actions;

export default codebookSlice.reducer;